import { deleteBankApi } from '@eastcoal/api/finance/bank/deleteBank'

import { ConfirmButton } from '@eastcoal/common/components/Button/ConfirmButton'
import { useFeedback } from '@eastcoal/common/hooks/useFeedback'
import { pick } from '@eastcoal/common/utils/object'

import { MEMBER_MANAGE_ACTION_UUID } from '../../../../../constants/uuid'
import { useMemberBankListStore } from '../../../Store/hooks/useStore'

import { MemberBankDeleteButtonProps } from './interface'

export const MemeberBankDeleteButton = ({
  record
}: MemberBankDeleteButtonProps) => {
  const { message } = useFeedback()

  const { tableRef } = useMemberBankListStore(state =>
    pick(state, ['tableRef'])
  )

  const handleConfirm = async () => {
    await deleteBankApi({ id: record.id })
    message.success('账号删除成功')
    tableRef.current?.reload()
  }

  return record.defaultBank ? null : (
    <ConfirmButton
      danger
      message={`确定删除该账户吗？`}
      uuid={MEMBER_MANAGE_ACTION_UUID}
      onConfirm={handleConfirm}
    >
      删除
    </ConfirmButton>
  )
}
